import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { LinkButton } from '@communityshare/ui-shared';
import useHashScroll from '@/hooks/useHashScroll';
import AboutYouSection from './AboutYouSection';
import LocationSection from './LocationSection';
import YourInvolvementSection from './YourInvolvementSection';
import OpportunitiesSection from './OpportunitiesSection';
import PersonalInformationSection from './PersonalInformationSection';

export default function Layout() {
  const navigate = useNavigate();
  const { hash } = useLocation();

  useHashScroll(hash);

  return (
    <div className="p-8 space-y-8">
      <Helmet>
        <title>Edit Profile</title>
      </Helmet>

      <div className="flex items-center justify-between gap-4">
        <div className="text-3xl font-semibold text-cs-gray-900">
          Edit Profile
        </div>
        <LinkButton
          label="See how your profile is viewed by others"
          onClick={() => navigate('/profile/view')}
        />
      </div>

      <div className="divide-y divide-gray-200">
        <AboutYouSection />
        <LocationSection />
        <YourInvolvementSection />
        <OpportunitiesSection />
        <PersonalInformationSection />
      </div>
    </div>
  );
}
